const RenderMgr = require('../RenderMgr');
const PieChartRenderer = require('./PieChartRenderer');
const BarChartRenderer = require('./BarChartRenderer');
const SimplePanelRenderer = require('./SimplePanelRenderer');
const FeatureBuilder = require('../../utils/builder/FeatureBuilder');

/**
 * @constructor
 * @classdesc 统计渲染管理器
 * @augments G.render.RenderMgr
 * @alias G.render.StatisticsRenderMgr
 * @param {Object} options  构造参数
 * @param {G.Map} options.map  地图对象
 * @example
 * //使用示例代码
 * //todo
 */
let component = RenderMgr.extend({
    options: {},
    initialize(options) {
        RenderMgr.prototype.initialize.call(this, options);
        //
    },

    /**
     * @inheritDoc
     */
    addListeners() {
        this.map.listen('resolutionchanged', this._onResolutionChanged, this);
        this.map.listen('click', this._onClick, this);
    },

    /**
     * @inheritDoc
     */
    removeListeners() {
        this.map.off('resolutionchanged', this._onResolutionChanged, this);
        this.map.off('click', this._onClick, this);
    },

    //
    _onResolutionChanged(event) {
        for (let i = this.featureTypeList.length - 1; i >= 0; i--) {
            let featureTypeObj = this.featureTypeList[i];
            let renderer = featureTypeObj.renderer;
            renderer.onResolutionChanged(event);
        }
    },

    _onClick(event) {
        for (let i = this.featureTypeList.length - 1; i >= 0; i--) {
            let featureTypeObj = this.featureTypeList[i];
            let renderer = featureTypeObj.renderer;
            renderer.onClick(event);
        }
    },

    /**
     * 添加数据
     * @memberOf  G.render.StatisticsRenderMgr.prototype
     * @param opts {Object}
     * @param opts.featureType {String} 业务数据类型标识
     * @param opts.featureName {String} 业务数据类型名称
     * @param opts.list {Array} 业务数据列表
     * @param opts.idField {String} 数据标识属性名
     * @param opts.geometryBuilder {G.utils.GeometryBuilder} 坐标构建器
     * @param opts.type {String} 渲染类型，1=饼图 , 2=柱状图 , 3=文本框
     * @param opts.renderOption {Object}
     * @param opts.renderOption.zoomRange {Object[]}  比例尺范围设定
     * @param opts.renderOption.style {Object|G.render.StatisticsRenderMgr~PanelRenderStyle}  显示样式
     * type=1参考{@link http://172.18.24.165/developer/guide/PieStatisticsChart1.html}，
     * type=2参考{@link http://172.18.24.165/developer/guide/BarStatisticsChart1.html},
     * type=3 参考 G.render.StatisticsRenderMgr~PanelRenderStyle
     * @param [opts.listeners] {Object} 事件监听
     */
    add(opts) {
        this._checkLoaded();
        this.remove(opts.featureType);
        let existFeatureTypeObj = this._getFeatureType(opts.featureType) || null;
        let featureTypeObj = existFeatureTypeObj || {};
        let RenderClazz = this._getRenderer(opts.type || 1);
        let featureBuilder = new FeatureBuilder({
            idField: opts.idField,
            geometryBuilder: opts.geometryBuilder
        });
        let renderer = new RenderClazz({
            id: opts.featureType,
            name: opts.featureName,
            map: this.map,
            idField: opts.idField,
            featureBuilder: featureBuilder,
            renderOption: opts.renderOption,
            eventDispatcher: this.eventDispatcher
        });
        renderer.add(opts.list);
        //
        featureTypeObj.featureType = opts.featureType;
        featureTypeObj.featureName = opts.featureName;
        featureTypeObj.idField = opts.idField;
        featureTypeObj.geometryBuilder = opts.geometryBuilder;
        featureTypeObj.renderer = renderer;
        if (existFeatureTypeObj == null) {
            this.featureTypeList.push(featureTypeObj);
        }
    },

    /**
     * 更新数据
     * @ignore
     * @method
     * @memberOf  G.render.StatisticsRenderMgr.prototype
     * @param opts {Object}
     * @param opts.featureType {String} 业务数据类型标识
     * @param opts.list {Array} 业务数据列表
     */
    update(opts) {
        this._checkLoaded();
        //
        let featureTypeObj = this._getFeatureType(opts.featureType);
        if (featureTypeObj) {
            featureTypeObj.renderer.update(opts.list);
        }
    },

    //
    _getRenderer(type) {
        let clazzMap = {
            1: PieChartRenderer,
            2: BarChartRenderer,
            3: SimplePanelRenderer
        }
        return clazzMap[type] || null;
    },

    /**
     * 获取业务类型对应的图层对象
     * @ignore
     * @method
     * @memberOf  G.render.StatisticsRenderMgr.prototype
     * @param featureType {String} 业务数据类型标识
     * @returns {g2.carto.ILayer}
     */
    getLayer(featureType) {
        let featureTypeObj = this._getFeatureType(featureType);
        if (featureTypeObj) {
            return featureTypeObj.renderer.getLayer();
        }
        return null;
    },


    /**
     * 销毁
     * @method
     * @memberOf  G.render.StatisticsRenderMgr.prototype
     */
    destroy() {
        //
        RenderMgr.prototype.destroy.call(this);
    }
});
module.exports = component;